module.exports = __webpack_public_path__ + "static/media/download-pdf-icon.78d76ba8.png";